import React, {ReactNode, useState} from 'react'
import {useFloating} from '@floating-ui/react'
import {DialogContext} from './DialogRootContext'

interface DialogRootProps {
    children?: ReactNode
    open?: boolean
    onOpenChange?: (open: boolean) => void
}

export function DialogRoot({
    children,
    open: controlledOpen,
    onOpenChange: setControlledOpen,
}: DialogRootProps) {
    const [uncontrolledOpen, setUncontrolledOpen] = useState(false)

    const open = controlledOpen ?? uncontrolledOpen
    const onOpenChange = setControlledOpen ?? setUncontrolledOpen

    const data = useFloating({
        open: open,
        onOpenChange: onOpenChange,
    })

    return (
        <DialogContext.Provider value={data}>
            {children}
        </DialogContext.Provider>
    )
}
